var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{on:{"click":function($event){return _vm.downloadBase64File(_vm.doc?.source?.data, _vm.doc?.title)}}},[_c('img',{staticClass:"document",attrs:{"src":`${_vm.publicPath}/icons/black-file-icon.svg`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }